import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { listaAction } from '../../store/lista';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Return, Select, SelectCentroCusto } from '../inspinia';
import CircularProgress from '@material-ui/core/CircularProgress';
import ModalSucesso from '../campanha/modalSucessoValidacao';
import { getToken, isAuthenticated } from '../../store/auth';

//Sweet Alert
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

class ListaCelularUpload extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state =
		{
			loading: false,

			form: this.formInitialState(),

			file: null,

			modalSucessoIsOpen: false,

			optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },

			alerta: withReactContent(Swal)
		}

		this.handleChange = this.handleChange.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.onChangeFile = this.onChangeFile.bind(this);
		this.handleSucessoToggle = this.handleSucessoToggle.bind(this);
	}

	formInitialState() {

		return {
			nomeListaContato: "",
			file: ""
		}

	}

	handleChange(e) {
		const form = this.state.form;

		this.setState({ form: { ...form, [e.target.name]: e.target.value } });
	}

	handleSucessoToggle(e) {
		this.setState({ ...this.state, modalSucessoIsOpen: !this.state.modalSucessoIsOpen });
	}

	onChangeFile(e) {
		const form = this.state.form;

		form.file = e.target.files[0];

		this.setState({ file: e.target.files[0] });

		if (form.file != null) {
			document.getElementsByClassName('custom-file-label').item(0).textContent = form.file.name
		} else {
			document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
		}
	}

	handleSave(e) {
		const self = this;
		const state = self.state;
		
		e.preventDefault();
		if (state.loading) return;
		if (!isAuthenticated()) return;
		self.setState({ ...state, loading: true });

		if (state.form.file === '') {
			c.TOASTER_ERROR('Favor incluir nome do arquivo e o arquivo.');
			self.setState({ ...state, loading: false });
			return;
		}

		let data = new FormData();
		data.append('file', state.file);

		let url = `${c.API_BASE_URL}/validacao-celular/file`;
		const _token = c.AUTH_HEADER(getToken());
		const options = {
            method: 'POST',
            body: data,
            headers: { 'Authorization': _token }
		};
		
		fetch(url, options).then(async (response) => {
			response.json().then(resp => {
				let titulo = "Validação de SMS";
				let mensagem = resp.message;
				let icon = "";

				if (resp.status === "OK") {
					icon = "success";
				} else {
					icon = "error";
				}

				state.alerta.fire({
					icon: icon,
					title: titulo,
					html: mensagem,
					confirmButtonColor: '#47A789',
				});
				self.setState({ ...state, loading: false });
				document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
                const file = document.querySelector('.file');
                file.value = '';
			});
		});
	}

	render() {
		const form = this.state.form;

		return (
			<div>

				<ModalSucesso isOpen={this.state.modalSucessoIsOpen} toggle={this.handleSucessoToggle} />

				{/* MAIN CONTENT */}
				<Row className="mb-5">
					<Column>
						<IBox>
							<Title className="pt-5 text-center">
								<h2 className="fs-20 fw-600 text-body">Validação de SMS</h2>
                                <br/>
								<h5 className="fs-14 fw-400 text-body">Tipos de Arquivos Permitidos: Formato de arquivos separados por ponto e vírgula (*.csv; .txt).</h5>
								<h5 className="fs-14 fw-400 text-body">O arquivo precisa conter a coluna 'SMS' com as informações dos números a serem validados.</h5>
								<p />
							</Title>

							<Content className="p-3 border-0">
								{/* FORMULÁRIO */}
								<Row className="m-0 mb-5">
									<Column size="9" className="container mx-auto p-0">

										<Row className="mt-4">
											<Column size="12" className="px-1">

												<div className="custom-file">
													<input type="file" name="file" className="custom-file-input file" id="validatedCustomFile" required value={this.state.arquivo} onChange={this.onChangeFile} />
													<label className="custom-file-label" for="validatedCustomFile">Selecione o arquivo</label>
												</div>

											</Column>
										</Row>

									</Column>
								</Row>

								{/* NAVEGAÇÃO */}
								<Row className="m-0 mb-3">
									<Column size="auto" className="mx-auto">
										<div className="input-group">

											<Return to={c.PANEL_ROUTE} className="mx-1" width="130px" />
											<Button onClick={this.handleSave} className="mx-1" width="130px">Enviar</Button>

											<div className="ml-4">
												{this.state.loading && (
													<CircularProgress
														size={30}
														thickness={4}
														color='inherit'
														variant='indeterminate' />
												)}
											</div>
										</div>
									</Column>
								</Row>
							</Content>
						</IBox>
					</Column>
				</Row>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return { auth: state.auth, lista: state.lista };
}
function mapDispatchToProps(dispatch) {
	return { actions: { lista: bindActionCreators(listaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListaCelularUpload));
